/* RE:VOIR — recherche dans les longues listes de filtres (Artiste, Label…).
   Le champ est volontairement isolé du formulaire de filtres : sans ça, chaque
   frappe relancerait un filtrage du thème. */
(function () {
  'use strict';

  function normalize(text) {
    return (text || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }

  function filterList(input) {
    var wrap = input.closest('.rv-facet-search');
    var list = wrap && wrap.nextElementSibling;
    if (list && list.tagName !== 'UL') list = list.querySelector('ul');
    if (!list || list.tagName !== 'UL') return;
    var query = normalize(input.value);
    var container = input.closest('.parent-display, .mobile-facets__submenu') || list.parentElement;

    list.toggleAttribute('data-rv-searching', query !== '');
    if (container) container.toggleAttribute('data-rv-searching', query !== '');

    list.querySelectorAll(':scope > li').forEach(function (li) {
      var label = li.querySelector('.facet-checkbox__text-label, .facets__label, label');
      var match = !query || normalize(label ? label.textContent : li.textContent).indexOf(query) !== -1;
      li.toggleAttribute('data-rv-nomatch', !match);
    });
  }

  // Phase de capture : on intercepte l'événement avant le formulaire de filtres.
  document.addEventListener('input', function (event) {
    if (!event.target.matches || !event.target.matches('[data-rv-facet-search]')) return;
    event.stopPropagation();
    filterList(event.target);
  }, true);

  // Entrée dans le champ ne doit pas soumettre le formulaire.
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target.matches && event.target.matches('[data-rv-facet-search]')) {
      event.preventDefault();
    }
  }, true);
})();
